import { eventHeads } from './projection';
import type { ClinicalEvent } from './types';
export function consentFollowupTasks(events: ClinicalEvent[]) {
  return eventHeads(events).filter(
    (e) =>
      e.event_type === 'CONSENT.DECISION' &&
      e.status !== 'STRUCK' &&
      e.payload.decision === 'DECLINED' &&
      (!e.payload.form_document_id || e.status !== 'ACTIVE'),
  );
}
